export default {
	methods: {
		convertDate (value, type) {
			if (value) {

				const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
				const date = new Date(value)
				const year = date.getFullYear()
				const month = months[date.getMonth()]
				const day = date.getDate()

				if (type === 'date') {
					return `${day} ${month} ${year}`
				}

				if (type === 'dateTime') {
					const hours = date.getHours()
					const minutes = '0' + date.getMinutes()
					return `${day} ${month} ${year}, ${hours}:${minutes.substr(-2)}`
				}

				if (type === 'dateWithoutYear') {
					return `${day} ${month}`
				}

			}
		}
	}
}
